import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import '../../styles/pages/AdminPages.css';

const API_URL = process.env.REACT_APP_API_URL;

function AdminMain({ onLogout }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/api/admin/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } finally {
      onLogout && onLogout();   // App 상태 업데이트
      navigate('/admin');       // 로그인 페이지로 이동
    }
  };

  // 공지 만들기 페이지로 이동
  const handleCreateNotice = () => {
    navigate('/admin/create-notice');
  };

  // "광고주 관리" 페이지 이동
  const handleGoAdvertiser = () => {
    navigate('/admin/advertiser');
  };

  // 인플루언서 관리 페이지 이동
  const handleGoInfluencer = () => {
    navigate('/admin/influencer');
  };

  // 포인트 관리 페이지 이동
  const handleGoPoint = () => {
    navigate('/admin/point');
  };  

  // 프로젝트 관리 페이지 이동
  const handleGoProject = () => {
    navigate('/admin/project');
  };
  
  // 매출 관리 페이지 이동
  const handleGoMoney = () => {
    navigate('/admin/money');
  };
   
  return (
    <AdminLayout title="관리자 대시보드" onLogout={handleLogout}>
      <div className="admin-main">
        <div className="admin-main__menu">
          <button className="admin-main__menu-button" onClick={handleGoAdvertiser}>
            광고주 관리
          </button>
          <button className="admin-main__menu-button" onClick={handleGoInfluencer}>
            인플루언서 관리
          </button>
          <button className="admin-main__menu-button" onClick={handleGoProject}>
            프로젝트 관리
          </button>
          <button className="admin-main__menu-button" onClick={handleGoPoint}>
            포인트 관리
          </button>
          <button className="admin-main__menu-button" onClick={handleGoMoney}>
            매출 관리
          </button>
          <button className="admin-main__menu-button" onClick={handleCreateNotice}>
            공지 만들기
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminMain;
